import React, { useState } from 'react';

import styles from './BudgetItem.module.css';
import RDSInput from '../../components/RDSInput';
import { DollarSignIcon } from '@ramsey-design-system/icons';
import { InformationOutlinedIcon } from '@ramsey-design-system/icons';
import { clamp, formatCents, parseCents } from '../../utils';
import Indicator from '../../components/Indicator';
import RDSIcon from '../../components/RDSIcon';
import Tooltip from '../../components/Tooltip';

type BudgetItemProps = {
  label: string;
  value: number;
  onBlur?: (amount: number) => void;
  color?: string;
  tooltipText?: string;
};

const BudgetItem = (props: BudgetItemProps) => {
  const [count, setCount] = useState(0);
  const constrainedValue = clamp(props.value, 0, 99999999);
  const blurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
    if (!props.onBlur) {
      return;
    }

    const parsedValue = parseCents(event.target.value, 0);
    const updatedValue = clamp(parsedValue, 0, 99999999);
    props.onBlur(updatedValue);
    // this forces a re-render every time the input is blurred, but lets us use an uncontrolled component
    setCount(count + 1);
  };

  return (
    <div className={styles.BudgetItem}>
      <label className={styles.Label}>
        {props.color ? (
          <Indicator color={props.color} className={styles.Indicator} />
        ) : null}
        <span className={styles.LabelText}>{props.label}</span>
        {props.tooltipText ? (
          <Tooltip
            text={props.tooltipText}
            direction="top"
            className={styles.Tooltip}
          >
            <RDSIcon
              icon={InformationOutlinedIcon}
              color="neutral"
              className={styles.InformationIcon}
            />
          </Tooltip>
        ) : null}
      </label>
      <RDSInput
        maxLength={10}
        data-testid={`budget_item_input-${props.label}`}
        className={styles.Input}
        defaultValue={formatCents(constrainedValue)}
        key={`${formatCents(constrainedValue)}-${count}`}
        icon={DollarSignIcon}
        onBlur={blurHandler}
        size="sm"
      />
    </div>
  );
};

export default BudgetItem;
